export type LanguageQuestionId = 'germanSkills' | 'englishSkills';

export type QuestionId = 'euWorkEligibility' | LanguageQuestionId;

export type PreScreeningAnswers = Record<QuestionId, string | undefined>;

type RadioOption = {
  labelId: string;
  value: string;
};

type RadioQuestion = {
  id: QuestionId;
  type: 'radio';
  labelId: string;
  options: RadioOption[];
};

type LanguageLevelQuestion = {
  id: LanguageQuestionId;
  type: 'languageLevel';
  labelId: string;
};

type Question = RadioQuestion | LanguageLevelQuestion;

export const questions: Question[] = [
  {
    id: 'euWorkEligibility',
    type: 'radio',
    labelId: 'JOBS_JOB_DETAILS_PRE_SCREENING_EU_WORK_ELIGIBILITY',
    options: [
      {
        labelId: 'JOBS_JOB_DETAILS_PRE_SCREENING_EU_WORK_ELIGIBILITY_YES',
        value: 'yes',
      },
      {
        labelId: 'JOBS_JOB_DETAILS_PRE_SCREENING_EU_WORK_ELIGIBILITY_NO',
        value: 'no',
      },
    ],
  },
  {
    id: 'germanSkills',
    type: 'languageLevel',
    labelId: 'JOBS_JOB_DETAILS_PRE_SCREENING_GERMAN_SKILLS',
  },
  {
    id: 'englishSkills',
    type: 'languageLevel',
    labelId: 'JOBS_JOB_DETAILS_PRE_SCREENING_ENGLISH_SKILLS',
  },
];

export const languageLevelOptions = [
  {
    labelId: 'PROFILE_LANGUAGES_LEVEL_1',
    value: '1',
  },
  {
    labelId: 'PROFILE_LANGUAGES_LEVEL_2',
    value: '2',
  },
  {
    labelId: 'PROFILE_LANGUAGES_LEVEL_3',
    value: '3',
  },
  {
    labelId: 'PROFILE_LANGUAGES_LEVEL_4',
    value: '4',
  },
];

export const questionTrackingElement: Record<QuestionId, string> = {
  englishSkills: 'english_language_skill',
  euWorkEligibility: 'eu_work_permit',
  germanSkills: 'german_language_skill',
};
